import { jsx } from 'react/jsx-runtime';
import { createCollection } from '@radix-ui/react-collection';
import { useContext } from 'react';
import { createGlobalReferenceContext } from '../../../utils/createGlobalReferenceContext.mjs';

const SELECT_NAME = "Select";
const [Collection, useCollection] = createCollection(SELECT_NAME);
const SelectSearchContext = createGlobalReferenceContext(
  `fx-SelectSearch`,
  {
    searchValue: "",
    onSearchValueChange: () => {
    },
    renderEmpty: false,
    onRenderEmptyChange: () => {
    }
  }
);
const SelectSearchProvider = (props) => {
  const { children, ...value } = props;
  return /* @__PURE__ */ jsx(SelectSearchContext.Provider, { value, children });
};
const useSelectSearchContext = () => {
  const context = useContext(SelectSearchContext);
  if (context === void 0) {
    throw new Error("MultiSelectSearch \uC548\uCABD\uC5D0\uC11C \uC0AC\uC6A9\uD574 \uC8FC\uC138\uC694");
  }
  return context;
};
const SelectContext = createGlobalReferenceContext(
  `fx-Select`,
  {
    value: "",
    open: false,
    onValueChange: () => {
    },
    onOpenChange: () => {
    },
    trigger: null,
    onTriggerChange: () => {
    },
    inputFocused: false,
    onInputFocusChange: () => {
    },
    hasEmptyView: false,
    onHasEmptyViewChange: () => {
    }
  }
);
const SelectProvider = (props) => {
  const { children, ...value } = props;
  return /* @__PURE__ */ jsx(SelectContext.Provider, { value, children });
};
const useSelectContext = () => {
  const context = useContext(SelectContext);
  if (context === void 0) {
    throw new Error("MultiSelectSearch \uC548\uCABD\uC5D0\uC11C \uC0AC\uC6A9\uD574 \uC8FC\uC138\uC694");
  }
  return context;
};

export { Collection, SelectProvider, SelectSearchProvider, useCollection, useSelectContext, useSelectSearchContext };
//# sourceMappingURL=context.mjs.map
